import React from "react";
import { observer } from "mobx-react";
import { ChangeSubscriptionPlanTemplate } from "themes/application/payment/pages";
import { ChangeSubscriptionPlanViewStore } from "application/payment/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new ChangeSubscriptionPlanViewStore(rootStore, componentProps),
    "changeSubscriptionPlanViewStore"
)
@observer
class ChangeSubscriptionPlan extends React.Component {
    render() {
        return <ChangeSubscriptionPlanTemplate {...this.props} />;
    }
}

export default ChangeSubscriptionPlan;
